var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvalanche(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1514_26514)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#E84142"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.665 55.918H20.9021C19.2709 55.918 18.4652 55.918 17.9739 55.6037C17.4432 55.2596 17.1189 54.6897 17.0796 54.0607C17.0501 53.4812 17.4531 52.7735 18.2588 51.3585L37.4263 17.5731C38.2419 16.1384 38.6546 15.4211 39.1754 15.1558C39.7355 14.8708 40.4037 14.8708 40.9638 15.1558C41.4846 15.4211 41.8974 16.1384 42.7129 17.5731L46.6534 24.4516L46.6735 24.4867C47.5544 26.0258 48.0011 26.8063 48.1961 27.6255C48.4123 28.5197 48.4123 29.4631 48.1961 30.3573C47.9996 31.1827 47.5574 31.9688 46.6632 33.5312L36.5949 51.329L36.5689 51.3746C35.6822 52.9264 35.2328 53.7129 34.61 54.3063C33.932 54.955 33.1164 55.4264 32.2222 55.6921C31.4066 55.918 30.4927 55.918 28.665 55.918ZM48.2688 55.918H59.3921C61.0331 55.918 61.8587 55.918 62.3503 55.5941C62.8808 55.2501 63.2148 54.67 63.2446 54.0415C63.2728 53.4807 62.8787 52.8005 62.1064 51.4677C62.0797 51.4224 62.0531 51.3762 62.0259 51.3292L56.4542 41.7976L56.3908 41.6903C55.6078 40.3663 55.2126 39.6977 54.705 39.4393C54.1453 39.1542 53.4864 39.1542 52.9266 39.4393C52.4156 39.7045 52.0029 40.4022 51.1873 41.8074L45.6353 51.3391L45.6163 51.3719C44.8036 52.7748 44.3974 53.4759 44.4267 54.0511C44.466 54.6802 44.7903 55.2596 45.3209 55.6037C45.8024 55.918 46.6278 55.918 48.2688 55.918Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1514_26514"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvalanche);
export default __webpack_public_path__ + "static/media/avalanche.9a08ca316958cf8c77782eda7a0471ad.svg";
export { ForwardRef as ReactComponent };